import { render } from "./transactions-list-component.vue?vue&type=template&id=15a154ec&ts=true"
import script from "./transactions-list-component.vue?vue&type=script&lang=ts"
export * from "./transactions-list-component.vue?vue&type=script&lang=ts"

import "./transactions-list-component.vue?vue&type=style&index=0&id=15a154ec&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__